import useStyles from './styles';

import React from 'react';

export interface IProps {
  show?: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
  loggedErrors?: string[];
}

const BzErrorFlat: React.FC<IProps> = React.memo(
  ({ children, error, errorInfo, loggedErrors, show, ...props }) => {
    const classes = useStyles(props);

    return (
      <div className={classes.root}>
        {children}
        {show && (
          <>
            {!!error && (
              <div>
                <pre>
                  <strong>{error.name}</strong>
                  {error.message}
                </pre>
                {error.cause && (
                  <>
                    <pre>{error.cause}</pre>
                    <br />
                  </>
                )}
                <br />
                <pre>{error.stack}</pre>
              </div>
            )}
            {!!errorInfo && <div>{errorInfo.componentStack}</div>}
            {!!loggedErrors && (
              <div>
                {loggedErrors.map((loggedError, idx) => {
                  return <div key={idx}>{loggedError}</div>;
                })}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
);

BzErrorFlat.defaultProps = {
  show: false
};

BzErrorFlat.displayName = 'BzErrorFlat';

export default BzErrorFlat;
